import { errorMessagesSection, faExclamationCircle, FormStyle,
         infoPlaceholderSection, React} from "@/imports-files/components/custom-datetime";
import Autosuggest from "react-autosuggest";


export function AutosuggestInput(props)
{
 return(
           <React.Fragment>
                <Autosuggest 
                    suggestions                  =  {props?.suggestions}
                    onSuggestionsFetchRequested  =  {props?.onSuggestionsFetchRequested}
                    onSuggestionsClearRequested  =  {props?.onSuggestionsClearRequested}
                    getSuggestionValue           =  {props?.getSuggestionValue}
                    renderSuggestion             =  {props?.renderSuggestion}
                    renderInputComponent         =  {props?.renderInputComponent}
                    shouldRenderSuggestions      =  {props?.shouldRenderSuggestions}
                    onSuggestionSelected         =  {props?.onSuggestionSelected}
                    inputProps                   =  {props?.inputProps}
                    multiSection                 =  {props.multiSection}
                    getSectionSuggestions        =  {props.getSectionSuggestions || (() => [])}
                    renderSectionTitle           =  {props.renderSectionTitle || (() => null)}
                    >
                </Autosuggest>
               {
                    
                   props?.inputProps?.style != undefined ?  errorMessagesSection( props?.inputProps?.name, FormStyle, props?.inputProps?.formik, props.custom_class || '', props.custom_error_90 || '')
                                                       :  ''
               }
               
           </React.Fragment>
       )
}



